import { selectedProductId } from './model'

export function fleetListLineColors (option = {}) {
  const color = (value, fallback) => typeof value === 'string' && value.trim() ? value : fallback
  const borderColor = color(option.borderColor, '#255267')
  // 旧实例缺少新配置时保持原样；编辑外边框时由面板先固定当前分隔线颜色。
  return { borderColor, separatorColor: color(option.separatorColor, borderColor) }
}

export function waitingForPageProduct (kind, option = {}, context = {}, editing = false) {
  if (kind !== 'device' || option.productScope !== 'current') return false
  const id = selectedProductId(option, context, editing)
  return id === undefined || id === null || (typeof id === 'string' && !id.trim())
}
